import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnChannel } from '../../../models';
import { SnChannelsService } from '../../../services/channels.service';

export interface ISnEditChannelDialogData {
  channel: SnChannel;
}

@Component({
  templateUrl: './edit-channel-form.dialog.html',
})
export class SnEditChannelFormDialogComponent implements OnDestroy {
  public readonly channel: SnChannel;

  public isLoading = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ISnEditChannelDialogData,
    private readonly _matDialogRef: MatDialogRef<SnEditChannelFormDialogComponent>,
    private readonly _channelsService: SnChannelsService,
  ) {
    this.channel = data.channel;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onDialogSent(formData: Object): void {
    const userIds = this.channel.users.map((user) => user.id);

    this.isLoading = true;
    this._channelsService
      .updateOrganizationChannel(this.channel.sid, formData, userIds)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => (this.isLoading = false)),
      )
      .subscribe((channel) => {
        this._matDialogRef.close(channel);
      });
  }
}
